var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.769 7.468A5.307 5.307 0 0 1 10 5.364c1.419 0 2.753.552 3.757 1.556l.414.414 3.314-3.315-.414-.414a9.934 9.934 0 0 0-7.07-2.929 9.935 9.935 0 0 0-7.565 3.458l3.333 3.334ZM16.541 18.24A9.935 9.935 0 0 0 20 10.676c0-.608-.055-1.218-.164-1.812l-.088-.48H9.414v4.688h5.33a5.287 5.287 0 0 1-1.531 1.84l3.329 3.328ZM12.172 15.528a5.323 5.323 0 0 1-6.403-1.643l-3.333 3.333A9.935 9.935 0 0 0 10 20.677c2.028 0 3.963-.601 5.605-1.716l-3.433-3.433ZM5.15 12.845a5.282 5.282 0 0 1-.463-2.17c0-.771.166-1.506.464-2.168L1.715 5.07A9.928 9.928 0 0 0 0 10.676c0 2.028.6 3.963 1.715 5.605l3.436-3.436Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .676)",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgGoogle;